export const PROVIDER_ACCOUNT_STATE = {
  LOGIN_IN_PROGRESS: 'LOGIN_IN_PROGRESS',
  MFA_REQUIRED: 'MFA_REQUIRED',
  MFA_IN_PROGRESS: 'MFA_IN_PROGRESS',
  AUTHENTICATED: 'AUTHENTICATED',
  ERROR: 'ERROR',
  ACTIVE: 'ACTIVE',
};

// from https://github.com/NerdWallet/query0/blob/418cef7ed76e79c0ec371d4fddb9f033288eb2fa/src/schema/financialData/constants.js#L15-L25
export const FINANCIAL_PORTAL_PRIMARY_SOURCES = {
  NERDWALLET: 'NERDWALLET',
  PLAID: 'PLAID',
  QA: 'QA',
  USER: 'USER',
  YODLEE: 'YODLEE',
};

export const CASH_FLOW_CATEGORIES = {
  SPENDING: 'spending',
  EARNING: 'earning',
};

export const EVERYTHING_ELSE_CATEGORY_KEY = 'EVERYTHING_ELSE';

export const TRANSACTION_CATEGORIES_V2 = {
  CHILDCARE: 'CHILDCARE',
  DONATIONS: 'DONATIONS',
  ENTERTAINMENT: 'ENTERTAINMENT',
  FEES: 'FEES',
  GROCERIES: 'GROCERIES',
  HEALTH: 'HEALTH',
  HOUSING: 'HOUSING',
  INCOME: 'INCOME',
  INSURANCE: 'INSURANCE',
  OTHER: 'OTHER',
  PETS: 'PETS',
  RESTAURANTS: 'RESTAURANTS',
  SHOPPING: 'SHOPPING',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  TRANSFERS: 'TRANSFERS',
  TRANSPORT: 'TRANSPORT',
  TRAVEL: 'TRAVEL',
  UNCATEGORIZED: 'UNCATEGORIZED',
  UTILITIES: 'UTILITIES',
};

export const USER_PREFERRED_INCOME_ESTIMATE_SOURCES = {
  PROJECTED: 'PROJECTED',
  USER_REPORTED: 'USER_REPORTED',
};
